import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../../actions/layoutActions";
import { CreateProjectType } from "./CreateProjectType";
import {
  performCreateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { projectTypeDataComponentId } from "../ProjectTypeContainer";
import { useCreateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { convertServerErrorToFormikErrors } from "../../../../../../utils/formValidationUtils";
import propTypes from "../../../../../../constants/propTypes";

const CreateProjectTypeContainer = ({
  dataComponent,
  performCreateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
}) => {
  useCreateProcessRequests(dataComponent, {
    onSuccess: () => {
      showSnackNotificationAction("Project Type created successfully.");
      setReload(projectTypeDataComponentId, true);
      closeModalDialog();
    },
    onError: error => {
      const convertedError = convertServerErrorToFormikErrors(error);
      showSnackNotificationAction(convertedError.name);
    },
  });

  const handleCreateProjectType = values => {
    performCreateRequest(projectTypeDataComponentId, values);
  };

  return (
    <CreateProjectType
      handleCreateProjectType={handleCreateProjectType}
      closeModalDialog={closeModalDialog}
    />
  );
};

CreateProjectTypeContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  performCreateRequest: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dataComponent: getDataComponent(projectTypeDataComponentId, state),
  };
};

const mapDispatchToProps = {
  performCreateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateProjectTypeContainer);
